// Styles
import styles from './Table.module.css';

/**
 * Table component
 * @param {object} params
 * @param {JSX.Element} params.children
 * @param {number | string | null} [params.width] - The width of the table in pixels or percentage (e.g. '100%', '100px', etc.)
 * @returns {JSX.Element}
 */
function Table({ width = null, children }) {
  return (
    <table
      className={styles.table}
      {...{
        style: {
          width,
        },
      }}
    >
      {children}
    </table>
  );
}

export default Table;
